module.exports = __webpack_public_path__ + "img/logo-icon.6eae4653.png";